import React from "react";
import frame from "../../assets/Privacypolicy/Frame.svg";
import HeaderThree from "../../components/header/HeaderThree";
import { Helmet } from "react-helmet";
import FooterTwo from "../../components/footer/FooterTwo";
import CopyRightTwo from "../../components/footer/CopyRightTwo";
// import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
     <div className="main-page-wrapper overflow-x-hidden">
      <Helmet>
        <title>Customer Support || Deski-Saas & Software React Template</title>
      </Helmet>
      <HeaderThree />
    <div className="privacy-policy-container">
      <div className="privacy-policy-content">
        <div className="header-section">
          <h1 className="main-title">Privacy Policy</h1>
          <p className="description">
            This Privacy Policy describes Our policies and procedures on the
            collection, use and disclosure of Your information when You use the
            Service and tells You about Your privacy rights and how the law
            protects You.
          </p>
        </div>

        <div className="interpretation-section">
          <h2 className="section-title">Interpretation and Definitions</h2>
          
          <div className="subsection">
            <h3 className="subsection-title">Interpretation</h3>
            <p className="text-content">
              The words of which the initial letter is capitalized have meanings
              defined under the following conditions. The following definitions
              shall have the same meaning regardless of whether they appear in
              singular or in plural.
            </p>
          </div>

          <div className="subsection">
            <h3 className="subsection-title">Definitions</h3>
            <p className="intro-text">For the purposes of this Privacy Policy:</p>
            
            <div className="definitions-list">
              <div className="definition-item">
                <span className="term">Account</span>
                <span className="definition"> means a unique account created for You to access our Service or parts of our Service.</span>
              </div>

              <div className="definition-item">
                <span className="term">Affiliate</span>
                <span className="definition"> means an entity that controls, is controlled by or is under common control with a party, where "control" means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.</span>
              </div>

              <div className="definition-item">
                <span className="term">Country</span>
                <span className="definition"> refers to: Tamil Nadu, India</span>
              </div>

              <div className="definition-item">
                <span className="term">Device</span>
                <span className="definition"> means any device that can access the Service such as a computer, a cellphone or a digital tablet.</span>
              </div>

              <div className="definition-item">
                <span className="term">Personal Data</span>
                <span className="definition"> is any information that relates to an identified or identifiable individual.</span>
              </div>

              <div className="definition-item">
                <span className="term">Service</span>
                <span className="definition"> refers to the Website.</span>
              </div>

              <div className="definition-item">
                <span className="term">Service Provider</span>
                <span className="definition"> means any natural or legal person who processes the data on behalf of the Company. It refers to third-party companies or individuals employed by the Company to facilitate the Service, to provide the Service on behalf of the Company, to perform services related to the Service or to assist the Company in analyzing how the Service is used.</span>
              </div>

              <div className="definition-item">
                <span className="term">Usage Data</span>
                <span className="definition"> refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).</span>
              </div>

              <div className="definition-item">
                <span className="term">Website</span>
                <span className="definition"> refers to Raiden Studios, accessible from </span>
                <a href="https://raiden.studio/" rel="noopener noreferrer" target="_blank" className="link" style={{color:'#FF9523'}}>
                  https://raiden.studio/
                </a>
                <span className="definition"> You means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.</span>
              </div>
            </div>
          </div>
        </div>

        <div className="data-collection-section">
          <h2 className="section-title">Collecting and Using Your Personal Data</h2>
          
          <div className="subsection">
            <h3 className="subsection-title">Types of Data Collected</h3>
            
            <div className="data-type">
              <h4 className="data-type-title">Personal Data</h4>
              <div className="frame-container">
                {/* <img className="frame-image" alt="Frame" src={frame} /> */}
              </div>
              <p className="text-content">
                While using Our Service, We may ask You to provide Us with certain
                personally identifiable information that can be used to contact or
                identify You. Personally identifiable information may include, but
                is not limited to:
              </p>
              
              <div className="data-list">
                <p>Email address</p>
                <p>First name and last name</p>
                <p>Phone number</p>
                <p>Address, State, Province, ZIP/Postal code, City</p>
                <p>Usage Data</p>
              </div>
            </div>

            <div className="data-type">
              <h4 className="data-type-title">Usage Data</h4>
              <div className="usage-data-content">
                <p className="text-content">
                  Usage Data is collected automatically when using the Service.
                </p>
                
                <p className="text-content">
                  Usage Data may include information such as Your Device's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that You visit, the time and date of Your visit, the time spent on those pages, unique device identifiers and other diagnostic data.
                </p>
                
                <p className="text-content">
                  When You access the Service by or through a mobile device, We may collect certain information automatically, including, but not limited to, the type of mobile device You use, Your mobile device unique ID, the IP address of Your mobile device, Your mobile operating system, the type of mobile Internet browser You use, unique device identifiers and other diagnostic data.
                </p>
                
                <p className="text-content">
                  We may also collect information that Your browser sends whenever You visit our Service or when You access the Service by or through a mobile device.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="cookies-section">
          <h2 className="section-title">Tracking Technologies and Cookies</h2>
          
          <p className="text-content">
            We use Cookies and similar tracking technologies to track the activity on Our Service and store certain information. Tracking technologies used include beacons, tags, and scripts to collect and track information and to improve and analyze Our Service. The technologies We use may include:
          </p>

          <div className="cookie-definitions">
            <div className="cookie-definition">
              <span className="term">Cookies or Browser Cookies:</span>
              <span className="definition"> A cookie is a small file placed on Your Device. You can instruct Your browser to refuse all Cookies or to indicate when a Cookie is being sent. However, if You do not accept Cookies, You may not be able to use some parts of our Service. Unless you have adjusted Your browser setting so that it will refuse Cookies, our Service may use Cookies.</span>
            </div>

            <div className="cookie-definition">
              <span className="term">Web Beacons:</span>
              <span className="definition"> Certain sections of our Service and our emails may contain small electronic files known as web beacons (also referred to as clear gifs, pixel tags, and single-pixel gifs) that permit the Company, for example, to count users who have visited those pages or opened an email and for other related website statistics (for example, recording the popularity of a certain section and verifying system and server integrity).</span>
            </div>
          </div>

          <p className="text-content">
            Cookies can be "Persistent" or "Session" Cookies. Persistent Cookies remain on Your personal computer or mobile device when You go offline, while Session Cookies are deleted as soon as You close Your web browser. You can learn more about cookies on TermsFeed website article.
          </p>

          <p className="text-content">
            We use both Session and Persistent Cookies for the purposes set out below:
          </p>

          <div className="cookie-types">
            <div className="cookie-type">
              <h4 className="cookie-type-title">Necessary / Essential Cookies</h4>
              <p className="cookie-details">
                <span className="detail-label">Type:</span>
                <span className="detail-value"> Session Cookies</span>
              </p>
              <p className="cookie-details">
                <span className="detail-label">Administered by:</span>
                <span className="detail-value"> Us</span>
              </p>
              <p className="cookie-details">
                <span className="detail-label">Purpose:</span>
                <span className="detail-value"> These Cookies are essential to provide You with the services available through the Website and to enable You to use certain features. They help to authenticate users and prevent fraudulent use of user accounts. Without these Cookies, the services that You have asked for cannot be provided, and We only use these Cookies to provide You with those services.</span>
              </p>
            </div>

            <div className="cookie-type">
              <h4 className="cookie-type-title">Functionality Cookies</h4>
              <p className="cookie-details">
                <span className="detail-label">Type:</span>
                <span className="detail-value"> Session Cookies</span>
              </p>
              <p className="cookie-details">
                <span className="detail-label">Administered by:</span>
                <span className="detail-value"> Us</span>
              </p>
              <p className="cookie-details">
                <span className="detail-label">Purpose:</span>
                <span className="detail-value"> These Cookies allow us to remember choices You make when You use the Website, such as remembering your login details or language preference. The purpose of these Cookies is to provide You with a more personal experience and to avoid You having to re-enter your preferences every time You use the Website.</span>
              </p>
            </div>

            <div className="cookie-type">
              <h4 className="cookie-type-title">Cookies Policy / Notice Acceptance Cookies</h4>
              <p className="cookie-details">
                <span className="detail-label">Type:</span>
                <span className="detail-value"> Session Cookies</span>
              </p>
              <p className="cookie-details">
                <span className="detail-label">Administered by:</span>
                <span className="detail-value"> Us</span>
              </p>
              <p className="cookie-details">
                <span className="detail-label">Purpose:</span>
                <span className="detail-value"> These Cookies identify if users have accepted the use of cookies on the Website.</span>
              </p>
            </div>
          </div>

          <p className="text-content">
            For more information about the cookies we use and your choices regarding cookies, please visit our Cookies Policy or the Cookies section of our Privacy Policy.
          </p>
        </div>

        <div className="data-usage-section">
          <h2 className="section-title">Using Your Personal Data</h2>
          
          <p className="intro-text">
            The Company may use Personal Data for the following purposes:
          </p>

          <div className="usage-list">
            <p className="text-content">
              To provide and maintain our Service, including to monitor the usage of our Service
            </p>
            <p className="text-content">
              To manage Your Account: to manage Your registration as a user of the Service. The Personal Data You provide can give You access to different functionalities of the Service that are available to You as a registered user.
            </p>
            <p className="text-content">
              For the performance of a contract: the development, compliance and undertaking of the purchase contract for the products, items or services You have purchased or of any other contract with Us through the Service.
            </p>
            <p className="text-content">
              To contact You:to contact You via email, telephone, SMS, or other equivalent forms of electronic communication, such as push notifications from a mobile application   regarding updates or informative communications related to the functionalities, products or contracted services, including the security updates, when necessary or reasonable for their implementation.
            </p>
            <p className="text-content">
              To provide You with news, special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless You have opted not to receive such information.
            </p>
            <p className="text-content">
              To manage Your requests: To attend and manage Your requests to Us.
            </p>
            <p className="text-content">
              For business transfers: We may use Your information to evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of Our assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which Personal Data held by Us about our Service users is among the assets transferred.
            </p>
            <p className="text-content">
              For other purposes: Additionally, We may use Your information for purposes such as data analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and to evaluate and improve our Service, products, services, marketing and your experience.
            </p>
          </div>

          <h3 className="subsection-title">Sharing Your Personal Data</h3>
          <p className="intro-text">
            We may share Your personal information in the following situations:
          </p>

          <div className="sharing-content">
            <p className="text-content">
              <strong>For business transfers:</strong> We may share or transfer Your personal information in connection with, or during negotiations of, any merger, sale of Company assets, financing, or acquisition of all or a portion of Our business to another company.
            </p>
            
            <p className="text-content">
              <strong>With Affiliates:</strong> We may share Your information with Our affiliates, in which case we will require those affiliates to honor this Privacy Policy. Affiliates include Our parent company and any other subsidiaries, joint venture partners or other companies that We control or that are under common control with Us.
            </p>
            
            <p className="text-content">
              <strong>With business partners:</strong> We may share Your information with Our business partners to offer You certain products, services or promotions.
            </p>
            
            <p className="text-content">
              <strong>With other users:</strong> when You share personal information or otherwise interact in the public areas with other users, such information may be viewed by all users and may be publicly distributed outside.
            </p>
            
            <p className="text-content">
              <strong>With Your consent:</strong> We may disclose Your personal information for any other purpose with Your consent.
            </p>
          </div>
        </div>

        <div className="data-retention-section">
          <h2 className="section-title">Retention of Your Personal Data</h2>
          
          <p className="text-content">
            The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.
          </p>
          
          <p className="text-content">
            The Company will also retain Usage Data for internal analysis. Such data is generally retained for a shorter period, except when this data is used to strengthen the security or to improve the functionality of Our Service, or We are legally obligated to retain this data for longer time periods.
          </p>
        </div>

        <div className="data-transfer-section">
          <h2 className="section-title">Transfer of Your Personal Data</h2>
          
          <p className="text-content">
            Your information, including Personal Data, is processed at the Company's operating offices and in any other places where the parties involved in the processing are located. It means that this information may be transferred to — and maintained on — computers located outside of Your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from Your jurisdiction.
          </p>
          
          <p className="text-content">
            Your consent to this Privacy Policy followed by Your submission of such information represents Your agreement to that transfer.
          </p>
          
          <p className="text-content">
            The Company will take all steps reasonably necessary to ensure that Your data is treated securely and in accordance with this Privacy Policy and no transfer of Your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of Your data and other personal information.
          </p>
        </div>

        <div className="data-deletion-section">
          <h2 className="section-title">Deletion of Your Personal Data</h2>
          
          <p className="text-content">
            You have the right to delete or request that We assist in deleting the Personal Data that We have collected about You.
          </p>
          
          <p className="text-content">
            Our Service may give You the ability to delete certain information about You from within the Service.
          </p>
          
          <p className="text-content">
            You may update, amend, or delete Your information at any time by signing in to Your Account, if you have one, and visiting the account settings section that allows you to manage Your personal information. You may also contact Us to request access to, correct, or delete any personal information that You have provided to Us.
          </p>
          
          <p className="text-content">
            Please note, however, that We may need to retain certain information when we have a legal obligation or lawful basis to do so.
          </p>
        </div>

        <div className="disclosure-section">
          <h2 className="section-title">Disclosure of Your Personal Data</h2>
          
          <div className="subsection">
            <h3 className="subsection-title">Business Transactions</h3>
            <p className="text-content">
              If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred. We will provide notice before Your Personal Data is transferred and becomes subject to a different privacy policy.
            </p>
          </div>

          <div className="subsection">
            <h3 className="subsection-title">Law Enforcement</h3>
            <p className="text-content">
              Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency).
            </p>
          </div>

          <div className="subsection">
            <h3 className="subsection-title">Other Legal Requirements</h3>
            <p className="text-content">
              The Company may disclose Your Personal Data in the good faith belief that such action is necessary to:
            </p>
            
            <div className="legal-requirements-list">
              <p>Comply with a legal obligation</p>
              <p>Protect and defend the rights or property of the Company</p>
              <p>Prevent or investigate possible wrongdoing in connection with the Service</p>
              <p>Protect the personal safety of Users of the Service or the public</p>
              <p>Protect against legal liability</p>
            </div>
          </div>
        </div>

        <div className="security-section">
          <h2 className="section-title">Security of Your Personal Data</h2>
          
          <p className="text-content">but please remember that no method of transmission over the Internet or method of electronic storage is 100% secure.
            The security of Your Personal Data is important to Us, . While We strive to use commercially acceptable means to protect Your Personal Data, We cannot guarantee its absolute security.
          </p>
        </div>

        <div className="children-privacy-section">
          <h2 className="section-title">Children's Privacy</h2>
          
          <p className="text-content">
            Our Service is not directed to anyone under the age of 13. We do not knowingly collect personally identifiable information from anyone under the age of 13. If You are a parent or guardian and You are aware that Your child has provided Us with Personal Data, please contact Us. If We become aware that We have collected Personal Data from anyone under the age of 13 without verification of parental consent, We take steps to remove that information from Our servers.
          </p>
          
          <p className="text-content">
            If We rely on consent as a legal basis for processing Your information and Your country requires parental consent, We may require Your parent's consent before We collect and use that information.
          </p>
        </div>

        <div className="links-section">
          <h2 className="section-title">Links to Other Websites</h2>
          
          <p className="text-content">
            Our Service may contain links to other websites that are not operated by Us. If You click on a third party link, You will be directed to that third party's site. We strongly advise You to review the Privacy Policy of every site You visit.
          </p>
          
          <p className="text-content">
            We have no control over, and assume no responsibility for, the content, privacy policies, or practices of any third-party sites or services.
          </p>
        </div>

        <div className="changes-section">
          <h2 className="section-title">Changes to this Privacy Policy</h2>
          
          <p className="text-content">
            We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on this page.
          </p>
          
          <p className="text-content">
            We will let You know via email and/or a prominent notice on Our Service, prior to the change becoming effective and update the "Last updated" date at the top of this Privacy Policy.
          </p>
          
          <p className="text-content">
            You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.
          </p>
        </div>

        <div className="contact-section">
          <h2 className="section-title">Contact Us</h2>
          
          <p className="text-content">
            If you have any questions about this Privacy Policy, You can contact us at:
          </p>
          <p className="contact-info " style={{color:'#FF9523'}}>• By email: info@raiden.studio</p>
        </div> 
      </div>
    </div>

    <footer className="theme-footer-two pt-80 padt">
        <div className="top-footer">
          <div className="container">
            <FooterTwo />
          </div>
        </div>
        <div className="container">
          <div className="bottom-footer-content">
            <CopyRightTwo />
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPolicy;